import InnerComponent from '@Components/Sales/Invoice';
import orgContainer from '@Components/AppContainer';

const ListInvoices = () => ((orgContainer(InnerComponent)));
export default ListInvoices;
